/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { TemplateConstants } from "./TemplateConstants";
import { TemplateExpressionToken } from "./TemplateExpressionToken";
import { TemplateExpressionTokenType } from "./TemplateExpressionTokenType";
var TemplateExpressionScanner = /** @class */ (function () {
    function TemplateExpressionScanner(expression) {
        this.Expression = expression;
        this.Enumerator = TemplateExpressionScanner.parseExpression(this.Expression);
        this.moveNext();
    }
    TemplateExpressionScanner.prototype.tryAcceptToken = function (type) {
        if (this.CurrentToken.Type === type) {
            var acceptedToken = { token: this.CurrentToken, accepted: true };
            this.moveNext();
            return acceptedToken;
        }
        return { token: null, accepted: false };
    };
    TemplateExpressionScanner.prototype.tryAcceptIdentifier = function (value) {
        if (this.CurrentToken.Type === TemplateExpressionTokenType.Identifier && value === this.CurrentToken.Value) {
            this.moveNext();
            return true;
        }
        return false;
    };
    TemplateExpressionScanner.prototype.expectToken = function (type) {
        if (this.CurrentToken.Type === type) {
            var token = this.CurrentToken;
            this.moveNext();
            return token;
        }
        throw new Error("Unexpected template expression token. Expected token: ".concat(type, ". Actual token: ").concat(this.CurrentToken.Type, "."));
    };
    TemplateExpressionScanner.prototype.moveNext = function () {
        var result = this.Enumerator.next();
        this.HasToken = !result.done;
        this.CurrentToken = this.HasToken ? result.value : TemplateExpressionToken.EndOfData;
    };
    TemplateExpressionScanner.isSupportedIdentifierCharacter = function (character) {
        var regexpr = new RegExp("^[a-z0-9]+$", "i");
        return regexpr.test(character) || character === "$" || character === "_";
    };
    TemplateExpressionScanner.scanForward = function (expression, startPosition, predicate) {
        while (startPosition < expression.length && predicate(expression[startPosition])) {
            startPosition++;
        }
        return startPosition;
    };
    TemplateExpressionScanner.parseExpression = function (expression) {
        var currentPosition, startPosition, _a, tokenType, numberValue, parsedNumber, parsedNumber, identifier;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (expression.length > TemplateConstants.TemplateExpressionLimit) {
                        throw new Error("Template expression length limit exceeded. Limit: ".concat(TemplateConstants.TemplateExpressionLimit, ". Expression length: ").concat(expression.length, "."));
                    }
                    currentPosition = 0;
                    _b.label = 1;
                case 1:
                    if (!(currentPosition < expression.length)) return [3 /*break*/, 28];
                    if (expression[currentPosition] === " ") {
                        return [3 /*break*/, 27];
                    }
                    startPosition = currentPosition;
                    _a = expression[currentPosition];
                    switch (_a) {
                        case ".": return [3 /*break*/, 2];
                        case ",": return [3 /*break*/, 4];
                        case "(": return [3 /*break*/, 6];
                        case ")": return [3 /*break*/, 8];
                        case "[": return [3 /*break*/, 10];
                        case "]": return [3 /*break*/, 12];
                        case "?": return [3 /*break*/, 14];
                        case "'": return [3 /*break*/, 16];
                    }
                    return [3 /*break*/, 18];
                case 2: return [4 /*yield*/, {
                        StartPosition: startPosition,
                        EndPosition: currentPosition,
                        Type: TemplateExpressionTokenType.Dot
                    }];
                case 3:
                    _b.sent();
                    return [3 /*break*/, 27];
                case 4: return [4 /*yield*/, {
                        StartPosition: startPosition,
                        EndPosition: currentPosition,
                        Type: TemplateExpressionTokenType.Comma
                    }];
                case 5:
                    _b.sent();
                    return [3 /*break*/, 27];
                case 6: return [4 /*yield*/, {
                        StartPosition: startPosition,
                        EndPosition: currentPosition,
                        Type: TemplateExpressionTokenType.LeftParenthesis
                    }];
                case 7:
                    _b.sent();
                    return [3 /*break*/, 27];
                case 8: return [4 /*yield*/, {
                        StartPosition: startPosition,
                        EndPosition: currentPosition,
                        Type: TemplateExpressionTokenType.RightParenthesis
                    }];
                case 9:
                    _b.sent();
                    return [3 /*break*/, 27];
                case 10: return [4 /*yield*/, {
                        StartPosition: startPosition,
                        EndPosition: currentPosition,
                        Type: TemplateExpressionTokenType.LeftSquareBracket
                    }];
                case 11:
                    _b.sent();
                    return [3 /*break*/, 27];
                case 12: return [4 /*yield*/, {
                        StartPosition: startPosition,
                        EndPosition: currentPosition,
                        Type: TemplateExpressionTokenType.RightSquareBracket
                    }];
                case 13:
                    _b.sent();
                    return [3 /*break*/, 27];
                case 14: return [4 /*yield*/, {
                        StartPosition: startPosition,
                        EndPosition: currentPosition,
                        Type: TemplateExpressionTokenType.QuestionMark
                    }];
                case 15:
                    _b.sent();
                    return [3 /*break*/, 27];
                case 16:
                    while (currentPosition < expression.length) {
                        currentPosition = TemplateExpressionScanner.scanForward(expression, currentPosition + 1, function (character) { return character != "'"; });
                        if (currentPosition + 1 < expression.length && expression[currentPosition + 1] == "'") {
                            currentPosition++;
                        }
                        else {
                            break;
                        }
                    }
                    if (currentPosition >= expression.length) {
                        throw new Error("Template expression has unterminated string. Expression: ".concat(expression, ". Current position: ").concat(currentPosition, "."));
                    }
                    return [4 /*yield*/, {
                            StartPosition: startPosition,
                            EndPosition: currentPosition,
                            Type: TemplateExpressionTokenType.Literal,
                            Value: expression.substr(startPosition + 1, currentPosition - startPosition - 1).replace(/''/g, "'")
                        }];
                case 17:
                    _b.sent();
                    return [3 /*break*/, 27];
                case 18:
                    if (!(expression[currentPosition] == "+" ||
                        expression[currentPosition] == "-" ||
                        TemplateExpressionScanner.isDigit(expression[currentPosition]))) return [3 /*break*/, 23];
                    currentPosition =
                        expression[currentPosition] == "+" || expression[currentPosition] == "-" ? currentPosition + 1 : currentPosition;
                    tokenType = TemplateExpressionTokenType.Integer;
                    currentPosition = TemplateExpressionScanner.scanForward(expression, currentPosition, TemplateExpressionScanner.isDigit);
                    if (currentPosition < expression.length && expression[currentPosition] == ".") {
                        tokenType = TemplateExpressionTokenType.Float;
                        currentPosition = TemplateExpressionScanner.scanForward(expression, currentPosition + 1, TemplateExpressionScanner.isDigit);
                    }
                    if (currentPosition + 1 < expression.length && (expression[currentPosition] == "e" || expression[currentPosition] == "E")) {
                        currentPosition =
                            expression[currentPosition + 1] == "+" || expression[currentPosition + 1] == "-"
                                ? currentPosition + 2
                                : currentPosition + 1;
                        tokenType = TemplateExpressionTokenType.Float;
                        currentPosition = TemplateExpressionScanner.scanForward(expression, currentPosition, TemplateExpressionScanner.isDigit);
                    }
                    if (currentPosition < expression.length &&
                        TemplateExpressionScanner.isSupportedIdentifierCharacter(expression[currentPosition])) {
                        throw new Error("Template expression has unexpected character ".concat(expression[currentPosition], " at position ").concat(currentPosition, "."));
                    }
                    numberValue = expression.substr(startPosition, currentPosition - startPosition);
                    currentPosition--;
                    if (!(tokenType == TemplateExpressionTokenType.Integer)) return [3 /*break*/, 20];
                    parsedNumber = Number.parseInt(numberValue);
                    if (Number.isNaN(parsedNumber)) {
                        throw new Error("Template expression has invalid integer number ".concat(parsedNumber, " at position ").concat(startPosition, "."));
                    }
                    return [4 /*yield*/, {
                            StartPosition: startPosition,
                            EndPosition: currentPosition,
                            Type: TemplateExpressionTokenType.Integer,
                            Value: parsedNumber
                        }];
                case 19:
                    _b.sent();
                    return [3 /*break*/, 22];
                case 20:
                    parsedNumber = Number.parseFloat(numberValue);
                    if (Number.isNaN(parsedNumber)) {
                        throw new Error("Template expression has invalid float number ".concat(parsedNumber, " at position ").concat(startPosition, "."));
                    }
                    return [4 /*yield*/, {
                            StartPosition: startPosition,
                            EndPosition: currentPosition,
                            Type: TemplateExpressionTokenType.Float,
                            Value: parsedNumber
                        }];
                case 21:
                    _b.sent();
                    _b.label = 22;
                case 22: return [3 /*break*/, 26];
                case 23:
                    if (!TemplateExpressionScanner.isSupportedIdentifierCharacter(expression[currentPosition])) return [3 /*break*/, 25];
                    currentPosition = TemplateExpressionScanner.scanForward(expression, currentPosition, TemplateExpressionScanner.isSupportedIdentifierCharacter);
                    identifier = expression.substr(startPosition, currentPosition - startPosition);
                    currentPosition--;
                    return [4 /*yield*/, {
                            StartPosition: startPosition,
                            EndPosition: currentPosition,
                            Type: TemplateExpressionTokenType.Identifier,
                            Value: identifier
                        }];
                case 24:
                    _b.sent();
                    return [3 /*break*/, 26];
                case 25: throw new Error("Template expression has unexpected character ".concat(expression[currentPosition], " at position ").concat(currentPosition, "."));
                case 26: return [3 /*break*/, 27];
                case 27:
                    ++currentPosition;
                    return [3 /*break*/, 1];
                case 28: return [2 /*return*/];
            }
        });
    };
    TemplateExpressionScanner.isDigit = function (char) {
        var parsedInt = Number.parseInt(char);
        if (Number.isNaN(parsedInt))
            return false;
        return parsedInt >= 0 && parsedInt < 10;
    };
    return TemplateExpressionScanner;
}());
export { TemplateExpressionScanner };
